"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var I18n = require("i18n-js");
var React = require("react");
var bind_1 = require("../../../bind");
var scroll_target_1 = require("@reverbdotcom/commons/dist/components/scroll_target");
var UP_ARROW = 38;
var DOWN_ARROW = 40;
var ESC = 27;
var ENTER = 13;
var TAB = 9;
var MOBILE_WEB_BREAKPOINT = 640;
var Input = /** @class */ (function (_super) {
    tslib_1.__extends(Input, _super);
    function Input() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Input.prototype.move = function (increaser) {
        var _this = this;
        var lastItemIdx = this.props.suggestions.length - 1;
        var selected = this.props.suggestions.find(function (suggestion) {
            return suggestion.positionEqual(_this.props.selectedSuggestion);
        });
        var newIdx = this.props.suggestions.indexOf(selected);
        newIdx += increaser;
        if (newIdx < 0) {
            newIdx = lastItemIdx;
        }
        if (newIdx > lastItemIdx) {
            newIdx = 0;
        }
        var suggestion = this.props.suggestions[newIdx];
        this.props.setSelectedSuggestion(suggestion);
    };
    Input.prototype.handleKeyDown = function (evt) {
        if (evt.ctrlKey || evt.metaKey) {
            // don't do anything if modifier keys are used
            return;
        }
        if (evt.keyCode === UP_ARROW) {
            evt.preventDefault();
            this.move(-1);
            return;
        }
        if (evt.keyCode === DOWN_ARROW) {
            evt.preventDefault();
            this.move(1);
            return;
        }
        if (evt.keyCode === ESC || evt.keyCode === TAB) {
            this.props.toggleDropdown(false);
            return;
        }
        if (evt.keyCode === ENTER) {
            evt.preventDefault();
            if (this.props.selectedSuggestion) {
                this.props.selectSuggestion(this.props.selectedSuggestion);
            }
            else {
                this.props.submit(this.props.value);
            }
        }
    };
    Input.prototype.handleFocus = function () {
        var shouldScroll = window && window.innerWidth < MOBILE_WEB_BREAKPOINT;
        if (shouldScroll)
            this.scrollTarget.scrollToTop();
        this.props.toggleDropdown(true);
    };
    Input.prototype.handleChange = function (evt) {
        this.props.handleInputChange(evt.target.value);
    };
    Input.prototype.bindRef = function (node) {
        this.textInput = node;
    };
    Input.prototype.render = function () {
        var _this = this;
        return (React.createElement(React.Fragment, null,
            React.createElement(scroll_target_1.default, { verticalOffset: -10, ref: function (r) { return _this.scrollTarget = r; } }),
            React.createElement("input", { type: "text", ref: this.bindRef, className: "site-search__controls__input", title: I18n.t('discovery.searchBar.inputTitle'), autoCorrect: "off", autoCapitalize: "off", tabIndex: 0, value: this.props.value, placeholder: this.props.placeholderText, onChange: this.handleChange, onKeyDown: this.handleKeyDown, onFocus: this.handleFocus })));
    };
    tslib_1.__decorate([
        bind_1.default
    ], Input.prototype, "handleKeyDown", null);
    tslib_1.__decorate([
        bind_1.default
    ], Input.prototype, "handleFocus", null);
    tslib_1.__decorate([
        bind_1.default
    ], Input.prototype, "handleChange", null);
    tslib_1.__decorate([
        bind_1.default
    ], Input.prototype, "bindRef", null);
    return Input;
}(React.Component));
exports.default = Input;
//# sourceMappingURL=input.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/site_search/input.js
// module id = T0Va
// module chunks = 20 21